/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Conversion uses big-integer math, so values far beyond 2⁵³ stay exact instead of losing precision like normal JavaScript numbers.`)
};

const es_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. La conversión usa aritmética de números grandes, por lo que los valores muy superiores a 2⁵³ permanecen exactos en lugar de perder precisión como lo harían los números JavaScript normales.`)
};

const de_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Die Umrechnung nutzt Big-Integer-Mathematik, sodass Werte weit über 2⁵³ exakt bleiben, statt wie normale JavaScript-Zahlen an Präzision zu verlieren.`)
};

const nl_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Conversie gebruikt big-integer wiskunde, dus waarden ver voorbij 2^53 blijven exact in plaats van precisie te verliezen zoals normale JavaScript-getallen.`)
};

const fr_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. La conversion utilise les mathématiques des grands entiers, donc les valeurs bien au-delà de 2^53 restent exactes au lieu de perdre en précision comme le ferait les nombres JavaScript normaux.`)
};

const it_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. La conversione utilizza la matematica dei big integer, quindi i valori ben al di là di 2⁵³ rimangono esatti invece di perdere precisione come i normali numeri JavaScript.`)
};

const pt_br2_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A conversão usa aritmética de inteiros grandes, portanto valores muito além de 2⁵³ permanecem exatos em vez de perder precisão como números JavaScript normais.`)
};

const pt_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. A conversão usa matemática de números inteiros grandes, portanto valores muito além de 2⁵³ permanecem exatos em vez de perder precisão como números JavaScript normais.`)
};

const ja_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。変換は高精度整数演算を使用するため、2^53 よりはるかに大きい値は正確に保持され、通常の JavaScript 数値のように精度が失われることはありません。`)
};

const zh_nb_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。转换使用大整数运算，因此远超 2⁵³ 的数值也能保持精确，不会像普通 JavaScript 数字那样丢失精度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq2_a", locale)
	if (locale === "en") return en_nb_faq2_a(inputs)
	if (locale === "es") return es_nb_faq2_a(inputs)
	if (locale === "de") return de_nb_faq2_a(inputs)
	if (locale === "nl") return nl_nb_faq2_a(inputs)
	if (locale === "fr") return fr_nb_faq2_a(inputs)
	if (locale === "it") return it_nb_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq2_a(inputs)
	if (locale === "pt") return pt_nb_faq2_a(inputs)
	if (locale === "ja") return ja_nb_faq2_a(inputs)
	return zh_nb_faq2_a(inputs)
};